<script setup>
import PrimaryButton from "@/Components/PrimaryButton.vue";

defineProps({
    type: {
        type: String,
        default: 'button',
    },
});
</script>

<template>
    <PrimaryButton :type="type" color="white">
        <slot/>
    </PrimaryButton>
</template>
